interface Variant {
    variant: string;
    title: string;
    subtitle?: string;
}

export function useGetVariant(featureFlagName: string, variants: Array<Variant>, control: Variant) {
    const { $posthog } = useNuxtApp();

    // TODO: This composable was built only for heros originally, refactor to work for different use cases
    const heroTitle = ref(control.title);
    const heroSubtitle = ref(control.subtitle);

    if ($posthog) {
        const posthog = $posthog();
        const featureFlag = posthog!.getFeatureFlag(featureFlagName);
        const variant = variants.find((v) => v.variant === featureFlag);
        if (variant) {
            heroTitle.value = variant.title;
            heroSubtitle.value = variant.subtitle;
        }
    }

    return {
        heroTitle,
        heroSubtitle,
    };
}
